
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Experience the thrill of water sports in Goa. From exciting jet skiing to relaxing scuba diving, enjoy a fun-filled day on the water with friends and family.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Dive into adventure with the best water sports package in Goa. Enjoy jet skiing, parasailing, and more at beautiful beaches.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Get ready for adventure with the Goa Water Sports Package. Enjoy thrilling activities like jet skiing and scuba diving at stunning beaches.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: 'water activities in goa, water activities in goa price, best water activities in goa, water activities in goa in june, water activities in goa beach, water activities in goa in september, water activities in goa for kids, best beach for water activities in goa, which beach is best for water activities in goa, water activities in goa location',
        },
       
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
  {
    title: "Thrilling Activities",
    text: "Experience heart-pounding adventures with exciting water sports like jet skiing, parasailing, and scuba diving!",
  },
  {
    title: "Fun for All Ages",
    text: "Whether you're a seasoned adventurer or a first-timer, there's a water sport for everyone to enjoy!",
  },
  {
    title: "Safety First",
    text: "All activities are conducted with safety in mind, with trained instructors ensuring a secure experience.",
  },
  {
    title: "Convenient Booking",
    text: "Easily book your water sports package through the Goa App for hassle-free planning and great deals!",
  },
],


    
      title: 'Water Activities in Goa - Water Activities in Goa Price',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/watersports/water-activities-in-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/watersports/water-activities-in-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/watersports/water-activities-in-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Water Activities in Goa",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Water Activities in Goa - Book @ ₹1499 Flat 40% Off",
  "description": "Enjoy the ultimate Water Activities in Goa with jet skiing, parasailing, banana boat, bumper, and speed boat rides for an action-packed experience!",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1499",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/watersports/water-activities-in-goa",
        "url": "https://www.goa.app/watersports/water-activities-in-goa",
        "name": "Water Activities in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-10-28T10%3A22%3A12.940Zboat-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ciByUAtQF3pviy2%2BJH0GHYHLel7sbuUYCvoH3AGzfx%2BU8OkRWUKevNvz3CeiUv06iUzPZRgccDsQpleDqvK%2Fv%2BA7Ix9zbY4UV2zWXDbXCHwzloZDpAW8bFz8fBGBvr0OZcG7dZBitdCQK9DGftnWInmiks73KoO6bptAf%2Bms3wrfHs%2BAmsLUJlVmSm002MmsZb7pg9KyEOUR8NmHmNOJy9EXJZNRo6jjyAC2xr7li3kX5hQ%2Fv6YaTizNWZZuNVUtF%2FXxBV11Oh7MKAaXpfdzjgfrU6ryRA5yoVfX3hPgdZzWiHSQDpblL0roihRv%2Bdp%2F4xhKncI%2Fxz%2F2meAH98Bnmg%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "The Water Activities in Goa offers an exciting mix of jet skiing, parasailing, banana boat rides, bumper rides, and speed boat experiences. Perfect for adventure lovers, this package promises thrills and unforgettable memories on Goa’s beautiful waters.",
        "breadcrumb": {
            "@id": "https://www.goa.app/watersports/water-activities-in-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/watersports/water-activities-in-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What water activities are available in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In Goa, you can enjoy a range of water activities such as jet skiing, parasailing, scuba diving, kayaking, banana boat rides, and snorkeling."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of water activities in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prices for water activities in Goa start at ₹899 for basic activities, with premium packages, including scuba diving, going up to ₹3,499."
      }
    },
    {
      "@type": "Question",
      "name": "Is scuba diving available in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Goa offers several scuba diving options for beginners and experienced divers as part of its water activity packages."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need prior experience for water activities?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most water activities in Goa are beginner-friendly, with professional guides available to assist, especially for scuba diving and jet skiing."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time for water activities in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time for water activities in Goa is between November and April when the sea conditions are perfect, and the weather is pleasant."
      }
    },
    {
      "@type": "Question",
      "name": "Are safety measures in place for water activities?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all operators in Goa ensure safety, providing necessary equipment like life jackets and helmets for all water activities."
      }
    },
    {
      "@type": "Question",
      "name": "Can I book water activities in Goa online?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, water activities in Goa can be easily booked online through several platforms, including the Goa App, which often features special deals."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for water activities in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Wearing a swimsuit or comfortable clothing, along with sunscreen and flip-flops, is recommended for water activities in Goa."
      }
    },
    {
      "@type": "Question",
      "name": "Are meals included in water activity packages?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some water activity packages in Goa include meals or refreshments, but it's best to confirm the details when booking your package."
      }
    },
    {
      "@type": "Question",
      "name": "How do I choose the best water activities in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To find the best water activities in Goa, browse online reviews, compare packages, and check for discounts on platforms like the Goa App."
      }
    }
  
        ]
      }
    ]
  };
},


};



  